import { User } from 'src/app/common/state/user/user.model';
import {
  checkIfB2b,
  checkIfDistrictOperator,
  checkIfE2L,
} from 'src/app/common/utilities/role-helpers';
import { PlanPermissionType } from '../../shared/dtos/plans.dto';
import type { PlanDetailsItemStateModel } from '../../shared/state/implementation-plan/implementation-plan.state';
import { PlansAPIResponse } from '../../shared/types/responses/plan.responses';

export interface PlanSearchParams {
  title?: string;
  school_year?: string;
  page: number;
  sort_by: string;
  sort_by_desc: string | boolean;
  expand: string;
  own_only?: number;
}

export const checkIfPlanEditor = (
  userData: User,
  plan: PlansAPIResponse | PlanDetailsItemStateModel
): boolean => {
  const hasEditorRole =
    checkIfB2b(userData) ||
    checkIfE2L(userData) ||
    checkIfDistrictOperator(userData);

  let hasExplicitPlanPermission = false;
  if (plan?.permissions) {
    hasExplicitPlanPermission = plan.permissions.some((permission) => {
      const permissionUserId = permission.user?.id ?? permission.user_id;
      return (
        permissionUserId === userData.id &&
        permission.permission === PlanPermissionType.EDIT
      );
    });
  }

  const isPlanCreator = plan?.creator_user_id === userData.id;

  return hasEditorRole || hasExplicitPlanPermission || isPlanCreator;
};
